// extracted by mini-css-extract-plugin
export default {"viewwrapper":"FileViewer_viewwrapper__GCamt","iframeviewer":"FileViewer_iframeviewer__Y7KS8"};